// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  margin:0;
  padding:0;
  box-sizing:border-box;
  font-family:"Inter",sans-serif;
}

body{
  background:#020617;
}

.login-page{
  min-height:100vh;
  display:flex;
  background:#030712;
  overflow:hidden;
}

/* LEFT SIDE */

.left-panel{
  flex:1.5 1;
  position:relative;
  padding:50px;
  background:
  radial-gradient(circle at top left,#0ea5e955,transparent 40%),
  radial-gradient(circle at bottom left,#9333ea55,transparent 40%),
  #020617;
  display:flex;
  flex-direction:column;
  justify-content:space-between;
}

.brand{
  display:flex;
  align-items:center;
  gap:18px;
 margin-bottom:50px;
  
}

.brand-icon{
    width:80px;
    height:auto;

    filter:
      drop-shadow(0 0 12px #00d4ff)
      drop-shadow(0 0 25px #8b5cf6)
      drop-shadow(0 0 45px #00d4ff);
}

.brand-logo{
  display:flex;
  align-items:center;
  gap:14px;
  margin-bottom:80px;
  z-index:10;
}
.main-logo{
  width:90px;
  height:90px;
  object-fit:contain;

  filter:
      drop-shadow(0 0 8px rgba(0,212,255,.35))
      drop-shadow(0 0 15px rgba(139,92,246,.25));

  transition:.3s;
}

.main-logo:hover{
  transform:scale(1.08);
}

.brand-text h1{
  margin:0;
  font-size:4rem;
  font-weight:800;
  letter-spacing:-1px;

  background:linear-gradient(
    90deg,
    #ffffff,
    #38bdf8,
    #8b5cf6
  );

  -webkit-background-clip:text;
  -webkit-text-fill-color:transparent;
}

.brand-text span{
  display:block;
  margin-top:8px;

  color:#94a3b8;

  font-size:14px;
  font-weight:700;

  letter-spacing:4px;
  text-transform:uppercase;
}


.hero-content{
  width: 100%;
   max-width:500px;
   z-index:2;
}
.hero-section{
  flex:1 1;
  display:flex;
  align-items:center;
  justify-content:space-between;
  width:100%;
  height:100%;
   margin-top:-65px;
}


.hero-content{
  
  z-index: 2;
   width:45%;
  min-width:600px;
  padding-left:20px;
}


.preview-image{
   width:55%;
   display:flex;
   justify-content:center;
   align-items:center;
}
.preview-image img{
  width: 100%;
  max-width: 500px; /* Increase/decrease as needed */
  height: auto;
  object-fit: contain;
  

  /* Remove unwanted box effect */
  border-radius: 0;
  box-shadow: none;
  background: transparent;

  /* Blend naturally with background */
  mix-blend-mode: screen;

  /* Add soft glow */
  filter:
    drop-shadow(0 0 25px rgba(0,212,255,0.25))
    drop-shadow(0 0 50px rgba(139,92,246,0.15));

  transition: 0.4s ease;
}

.preview-image img:hover{
  transform: scale(1.03);
}

.preview-image::before{
  content:"";
  position:absolute;

  width:450px;
  height:450px;

  background:radial-gradient(
    circle,
    rgba(0,212,255,0.08),
    transparent 70%
  );

  filter:blur(120px);

  z-index:-1;
}


.preview-image img:hover{
  transform:scale(1.02);
}
.preview-image{
   width:65%;
   display:flex;
   justify-content:center;
   align-items:center;
}


.hero-content span{
  background:linear-gradient(90deg,#00d4ff,#8b5cf6);
  -webkit-background-clip: text;
  -webvkit-text-fill-color:transparent;
}

.hero-content p{
  color:#94a3b8;
  font-size:18px;
  margin-top:30px;
  line-height:1.7;
}



.preview-image{
  display:flex;
  justify-content:center;
}



/* RIGHT SIDE */



.auth-card{
  width:100%;
  max-width:430px;
  background:rgba(10,15,30,.85);
  backdrop-filter:blur(18px);
  border:1px solid rgba(255,255,255,.08);
  border-radius:32px;
  padding:45px;
  box-shadow:
  0 0 40px rgba(0,212,255,.08),
  0 0 80px rgba(139,92,246,.08);
}

.auth-card h2{
  color:white;
  text-align:center;
  font-size:42px;
  margin-top:15px;
}

.subtitle{
  text-align:center;
  color:#94a3b8;
  margin-top:10px;
  margin-bottom:30px;
}

.auth-card input{
  width:100%;
  height:58px;
  padding:0 18px;
  border-radius:16px;
  border:1px solid rgba(255,255,255,.08);
  background:#0b1225;
  color:white;
  margin-bottom:18px;
  font-size:16px;
}

.auth-card input:focus{
  border-color:#00d4ff;
  box-shadow:0 0 20px rgba(0,212,255,.25);
}

.auth-card button{
  width:100%;
  height:58px;
  border:none;
  border-radius:16px;
  background:linear-gradient(90deg,#1d8fff,#8b5cf6);
  color:white;
  font-size:18px;
  font-weight:700;
  cursor:pointer;
  transition:.3s;
   
}

.auth-card button:hover{
  transform:translateY(-2px);
}

.error{
  background:#7f1d1d;
  color:#fecaca;
  padding:10px;
  border-radius:10px;
  margin-bottom:15px;
  text-align:center;
}

/* MOBILE */
@media (max-width:992px){

  .login-page{
    flex-direction:column;
    overflow-y:auto;
  }

  .hero-section{
    flex-direction:column;
  }

  .preview-image{
    display:none;
  }

  .left-panel{
    display:none;
  }

  .right-panel{
    width:100%;
    min-height:100vh;
    padding:20px;
    display:flex;
    justify-content:center;
    align-items:center;
  }

  .auth-card{
    width:100%;
    max-width:420px;
    padding:30px;
    min-height:auto;
    height:auto;
  }

  .auth-card h2{
    font-size:34px;
  }
}
html,
body{
  overflow-x:hidden;
}

.bg-glow{
  position:absolute;
  border-radius:50%;
  filter:blur(100px);
  animation:float 10s infinite ease-in-out;
}

.bg-glow-1{
  width:300px;
  height:300px;
  background:#00d4ff33;
  top:0;
  left:0;
}

.bg-glow-2{
  width:250px;
  height:250px;
  background:#8b5cf633;
  bottom:100px;
  left:150px;
}

.bg-glow-3{
  width:200px;
  height:200px;
  background:#2563eb33;
  top:250px;
  right:100px;
}

@keyframes float{
  0%{
    transform:translateY(0px);
  }

  50%{
    transform:translateY(-30px);
  }

  100%{
    transform:translateY(0px);
  }
}
.grid-bg{
  position:absolute;
  inset:0;

  background-image:
  linear-gradient(
    rgba(255,255,255,.04) 1px,
    transparent 1px
  ),

  linear-gradient(
    90deg,
    rgba(255,255,255,.04) 1px,
    transparent 1px
  );

  background-size:40px 40px;

  z-index:0;
}
@keyframes pulseLogo{

  0%{
    transform:scale(1);
  }

  50%{
    transform:scale(1.08);
  }

  100%{
    transform:scale(1);
  }

}
.particles span{

  position:absolute;

  width:4px;
  height:4px;

  border-radius:50%;

  background:#00d4ff;

  animation:particleFloat 12s infinite;
}

@keyframes particleFloat{

  0%{
    transform:translateY(100vh);
    opacity:0;
  }

  50%{
    opacity:1;
  }

  100%{
    transform:translateY(-100px);
    opacity:0;
  }

}
.hero-title{
    font-size: 50px;
    font-weight: 800;
    line-height: 1.15;
    max-width: 1000px;
}

.hero-title span{
  background: linear-gradient(
      90deg,
      #00d4ff 0%,
      #3b82f6 50%,
      #a855f7 100%
  );

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.gradient-line{
   width:90px;
   height:4px;
   border-radius:20px;

   background:linear-gradient(
      90deg,
      #00d4ff,
      #a855f7
   );

   margin:25px 0;
}

@media (max-width:768px){

  .left-panel{
    display:none;
  }

  .right-panel{
    width:100%;
    min-height:100vh;
    padding:20px;
  }

  .auth-card{
    width:100%;
    max-width:420px;
  }
}
.login-stats-grid{
  display:flex !important;
  flex-direction:row !important;
  flex-wrap:nowrap !important;
  gap:60px !important;
  width:max-content !important;
  margin-top:40px !important;
}

.stat-item{
  flex-shrink:0 !important;
}
.stat-item{
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  text-align:left;
}

.stat-item svg{
  font-size:40px;
  color:#7a48ee;
  margin-bottom:10px;
}

.stat-item h3{
  color:#fff;
  font-size:18px;
  font-weight:700;
  margin:0 0 8px 0;
  line-height:1;
}

.stat-item p{
  color:#94a3b8;
  font-size:13px;
  line-height:1.6;
  margin:0;
}
.login-options{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin:10px 0 20px;
}

.remember-me{
  display:flex;
  align-items:center;
  gap:8px;
  color:#cbd5e1;
  font-size:14px;
  cursor:pointer;
}

.remember-me input{
  width:16px;
  height:16px;
  margin:0;
  accent-color:#3b82f6;
}

.forgot-password{
  color:#3b82f6;
  text-decoration:none;
  font-size:14px;
}

.forgot-password:hover{
  color:#8b5cf6;
}
.logo-text{
  margin:0;
  font-size:36px;
  font-weight:800;
  letter-spacing:-1px;
  line-height:1;

  background:linear-gradient(
      90deg,
      #ffffff 0%,
      #dbeafe 30%,
      #7dd3fc 60%,
      #60a5fa 100%
  );

  -webkit-background-clip:text;
  -webkit-text-fill-color:transparent;

  text-shadow:
      0 0 10px rgba(96,165,250,.3),
      0 0 20px rgba(96,165,250,.2);
}
.logo-text::after{
  content:"InWallz";
  position:absolute;
  left:0;
  top:0;
  z-index:-1;

  background:linear-gradient(
    135deg,
    #60a5fa,
    #8b5cf6
  );

  -webkit-background-clip:text;
  -webkit-text-fill-color:transparent;

  filter:blur(18px);
  opacity:.6;
}
.login-logo{
  width:140px;
  display:block;
  margin:0 auto 15px;

  filter:
    drop-shadow(0 0 8px rgba(0,212,255,.4))
    drop-shadow(0 0 15px rgba(139,92,246,.3));
}`, "",{"version":3,"sources":["webpack://./src/styles/auth.css"],"names":[],"mappings":"AAAA;EACE,QAAQ;EACR,SAAS;EACT,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,cAAc;;AAEd;EACE,UAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ;;;SAGO;EACP,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;CACT,kBAAkB;;AAEnB;;AAEA;IACI,UAAU;IACV,WAAW;;IAEX;;;mCAG+B;AACnC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;;EAElB;;gDAE8C;;EAE9C,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,cAAc;EACd,eAAe;EACf,mBAAmB;;EAEnB;;;;;GAKC;;EAED,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,cAAc;;EAEd,aAAa;;EAEb,cAAc;EACd,eAAe;;EAEf,kBAAkB;EAClB,wBAAwB;AAC1B;;;AAGA;EACE,WAAW;GACV,eAAe;GACf,SAAS;AACZ;AACA;EACE,QAAM;EACN,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,UAAU;EACV,WAAW;GACV,gBAAgB;AACnB;;;AAGA;;EAEE,UAAU;GACT,SAAS;EACV,eAAe;EACf,iBAAiB;AACnB;;;AAGA;GACG,SAAS;GACT,YAAY;GACZ,sBAAsB;GACtB,kBAAkB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB,EAAE,gCAAgC;EAClD,YAAY;EACZ,mBAAmB;;;EAGnB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;;EAEvB,oCAAoC;EACpC,sBAAsB;;EAEtB,kBAAkB;EAClB;;+CAE6C;;EAE7C,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,iBAAiB;;EAEjB,WAAW;EACX,YAAY;;EAEZ;;;;GAIC;;EAED,kBAAkB;;EAElB,UAAU;AACZ;;;AAGA;EACE,qBAAqB;AACvB;AACA;GACG,SAAS;GACT,YAAY;GACZ,sBAAsB;GACtB,kBAAkB;AACrB;;;AAGA;EACE,iDAAiD;EACjD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;;;AAIA;EACE,YAAY;EACZ,sBAAsB;AACxB;;;;AAIA,eAAe;;;;AAIf;EACE,UAAU;EACV,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;EAC1B,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ;;+BAE6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,iDAAiD;EACjD,WAAW;EACX,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;;AAEhB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,WAAW;AACX;;EAEE;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF;AACA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,KAAK;EACL,MAAM;AACR;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,iBAAiB;EACjB,OAAO;;EAEP;;;;;;;;;;GAUC;;EAED,yBAAyB;;EAEzB,SAAS;AACX;AACA;;EAEE;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;AAEF;AACA;;EAEE,iBAAiB;;EAEjB,SAAS;EACT,UAAU;;EAEV,iBAAiB;;EAEjB,kBAAkB;;EAElB,oCAAoC;AACtC;;AAEA;;EAEE;IACE,2BAA2B;IAC3B,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,4BAA4B;IAC5B,SAAS;EACX;;AAEF;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;EACE;;;;;GAKC;;EAED,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;GACG,UAAU;GACV,UAAU;GACV,kBAAkB;;GAElB;;;;IAIC;;GAED,aAAa;AAChB;;AAEA;;EAEE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,QAAQ;AACV;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;AACA;EACE,QAAQ;EACR,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,aAAa;;EAEb;;;;;;GAMC;;EAED,4BAA4B;EAC5B,mCAAmC;;EAEnC;;kCAEgC;AAClC;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,MAAM;EACN,KAAK;EACL,UAAU;;EAEV;;;;GAIC;;EAED,4BAA4B;EAC5B,mCAAmC;;EAEnC,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;;EAElB;;6CAE2C;AAC7C","sourcesContent":["*{\n  margin:0;\n  padding:0;\n  box-sizing:border-box;\n  font-family:\"Inter\",sans-serif;\n}\n\nbody{\n  background:#020617;\n}\n\n.login-page{\n  min-height:100vh;\n  display:flex;\n  background:#030712;\n  overflow:hidden;\n}\n\n/* LEFT SIDE */\n\n.left-panel{\n  flex:1.5;\n  position:relative;\n  padding:50px;\n  background:\n  radial-gradient(circle at top left,#0ea5e955,transparent 40%),\n  radial-gradient(circle at bottom left,#9333ea55,transparent 40%),\n  #020617;\n  display:flex;\n  flex-direction:column;\n  justify-content:space-between;\n}\n\n.brand{\n  display:flex;\n  align-items:center;\n  gap:18px;\n margin-bottom:50px;\n  \n}\n\n.brand-icon{\n    width:80px;\n    height:auto;\n\n    filter:\n      drop-shadow(0 0 12px #00d4ff)\n      drop-shadow(0 0 25px #8b5cf6)\n      drop-shadow(0 0 45px #00d4ff);\n}\n\n.brand-logo{\n  display:flex;\n  align-items:center;\n  gap:14px;\n  margin-bottom:80px;\n  z-index:10;\n}\n.main-logo{\n  width:90px;\n  height:90px;\n  object-fit:contain;\n\n  filter:\n      drop-shadow(0 0 8px rgba(0,212,255,.35))\n      drop-shadow(0 0 15px rgba(139,92,246,.25));\n\n  transition:.3s;\n}\n\n.main-logo:hover{\n  transform:scale(1.08);\n}\n\n.brand-text h1{\n  margin:0;\n  font-size:4rem;\n  font-weight:800;\n  letter-spacing:-1px;\n\n  background:linear-gradient(\n    90deg,\n    #ffffff,\n    #38bdf8,\n    #8b5cf6\n  );\n\n  -webkit-background-clip:text;\n  -webkit-text-fill-color:transparent;\n}\n\n.brand-text span{\n  display:block;\n  margin-top:8px;\n\n  color:#94a3b8;\n\n  font-size:14px;\n  font-weight:700;\n\n  letter-spacing:4px;\n  text-transform:uppercase;\n}\n\n\n.hero-content{\n  width: 100%;\n   max-width:500px;\n   z-index:2;\n}\n.hero-section{\n  flex:1;\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  width:100%;\n  height:100%;\n   margin-top:-65px;\n}\n\n\n.hero-content{\n  \n  z-index: 2;\n   width:45%;\n  min-width:600px;\n  padding-left:20px;\n}\n\n\n.preview-image{\n   width:55%;\n   display:flex;\n   justify-content:center;\n   align-items:center;\n}\n.preview-image img{\n  width: 100%;\n  max-width: 500px; /* Increase/decrease as needed */\n  height: auto;\n  object-fit: contain;\n  \n\n  /* Remove unwanted box effect */\n  border-radius: 0;\n  box-shadow: none;\n  background: transparent;\n\n  /* Blend naturally with background */\n  mix-blend-mode: screen;\n\n  /* Add soft glow */\n  filter:\n    drop-shadow(0 0 25px rgba(0,212,255,0.25))\n    drop-shadow(0 0 50px rgba(139,92,246,0.15));\n\n  transition: 0.4s ease;\n}\n\n.preview-image img:hover{\n  transform: scale(1.03);\n}\n\n.preview-image::before{\n  content:\"\";\n  position:absolute;\n\n  width:450px;\n  height:450px;\n\n  background:radial-gradient(\n    circle,\n    rgba(0,212,255,0.08),\n    transparent 70%\n  );\n\n  filter:blur(120px);\n\n  z-index:-1;\n}\n\n\n.preview-image img:hover{\n  transform:scale(1.02);\n}\n.preview-image{\n   width:65%;\n   display:flex;\n   justify-content:center;\n   align-items:center;\n}\n\n\n.hero-content span{\n  background:linear-gradient(90deg,#00d4ff,#8b5cf6);\n  -webkit-background-clip: text;\n  -webvkit-text-fill-color:transparent;\n}\n\n.hero-content p{\n  color:#94a3b8;\n  font-size:18px;\n  margin-top:30px;\n  line-height:1.7;\n}\n\n\n\n.preview-image{\n  display:flex;\n  justify-content:center;\n}\n\n\n\n/* RIGHT SIDE */\n\n\n\n.auth-card{\n  width:100%;\n  max-width:430px;\n  background:rgba(10,15,30,.85);\n  backdrop-filter:blur(18px);\n  border:1px solid rgba(255,255,255,.08);\n  border-radius:32px;\n  padding:45px;\n  box-shadow:\n  0 0 40px rgba(0,212,255,.08),\n  0 0 80px rgba(139,92,246,.08);\n}\n\n.auth-card h2{\n  color:white;\n  text-align:center;\n  font-size:42px;\n  margin-top:15px;\n}\n\n.subtitle{\n  text-align:center;\n  color:#94a3b8;\n  margin-top:10px;\n  margin-bottom:30px;\n}\n\n.auth-card input{\n  width:100%;\n  height:58px;\n  padding:0 18px;\n  border-radius:16px;\n  border:1px solid rgba(255,255,255,.08);\n  background:#0b1225;\n  color:white;\n  margin-bottom:18px;\n  font-size:16px;\n}\n\n.auth-card input:focus{\n  border-color:#00d4ff;\n  box-shadow:0 0 20px rgba(0,212,255,.25);\n}\n\n.auth-card button{\n  width:100%;\n  height:58px;\n  border:none;\n  border-radius:16px;\n  background:linear-gradient(90deg,#1d8fff,#8b5cf6);\n  color:white;\n  font-size:18px;\n  font-weight:700;\n  cursor:pointer;\n  transition:.3s;\n   \n}\n\n.auth-card button:hover{\n  transform:translateY(-2px);\n}\n\n.error{\n  background:#7f1d1d;\n  color:#fecaca;\n  padding:10px;\n  border-radius:10px;\n  margin-bottom:15px;\n  text-align:center;\n}\n\n/* MOBILE */\n@media (max-width:992px){\n\n  .login-page{\n    flex-direction:column;\n    overflow-y:auto;\n  }\n\n  .hero-section{\n    flex-direction:column;\n  }\n\n  .preview-image{\n    display:none;\n  }\n\n  .left-panel{\n    display:none;\n  }\n\n  .right-panel{\n    width:100%;\n    min-height:100vh;\n    padding:20px;\n    display:flex;\n    justify-content:center;\n    align-items:center;\n  }\n\n  .auth-card{\n    width:100%;\n    max-width:420px;\n    padding:30px;\n    min-height:auto;\n    height:auto;\n  }\n\n  .auth-card h2{\n    font-size:34px;\n  }\n}\nhtml,\nbody{\n  overflow-x:hidden;\n}\n\n.bg-glow{\n  position:absolute;\n  border-radius:50%;\n  filter:blur(100px);\n  animation:float 10s infinite ease-in-out;\n}\n\n.bg-glow-1{\n  width:300px;\n  height:300px;\n  background:#00d4ff33;\n  top:0;\n  left:0;\n}\n\n.bg-glow-2{\n  width:250px;\n  height:250px;\n  background:#8b5cf633;\n  bottom:100px;\n  left:150px;\n}\n\n.bg-glow-3{\n  width:200px;\n  height:200px;\n  background:#2563eb33;\n  top:250px;\n  right:100px;\n}\n\n@keyframes float{\n  0%{\n    transform:translateY(0px);\n  }\n\n  50%{\n    transform:translateY(-30px);\n  }\n\n  100%{\n    transform:translateY(0px);\n  }\n}\n.grid-bg{\n  position:absolute;\n  inset:0;\n\n  background-image:\n  linear-gradient(\n    rgba(255,255,255,.04) 1px,\n    transparent 1px\n  ),\n\n  linear-gradient(\n    90deg,\n    rgba(255,255,255,.04) 1px,\n    transparent 1px\n  );\n\n  background-size:40px 40px;\n\n  z-index:0;\n}\n@keyframes pulseLogo{\n\n  0%{\n    transform:scale(1);\n  }\n\n  50%{\n    transform:scale(1.08);\n  }\n\n  100%{\n    transform:scale(1);\n  }\n\n}\n.particles span{\n\n  position:absolute;\n\n  width:4px;\n  height:4px;\n\n  border-radius:50%;\n\n  background:#00d4ff;\n\n  animation:particleFloat 12s infinite;\n}\n\n@keyframes particleFloat{\n\n  0%{\n    transform:translateY(100vh);\n    opacity:0;\n  }\n\n  50%{\n    opacity:1;\n  }\n\n  100%{\n    transform:translateY(-100px);\n    opacity:0;\n  }\n\n}\n.hero-title{\n    font-size: 50px;\n    font-weight: 800;\n    line-height: 1.15;\n    max-width: 1000px;\n}\n\n.hero-title span{\n  background: linear-gradient(\n      90deg,\n      #00d4ff 0%,\n      #3b82f6 50%,\n      #a855f7 100%\n  );\n\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.gradient-line{\n   width:90px;\n   height:4px;\n   border-radius:20px;\n\n   background:linear-gradient(\n      90deg,\n      #00d4ff,\n      #a855f7\n   );\n\n   margin:25px 0;\n}\n\n@media (max-width:768px){\n\n  .left-panel{\n    display:none;\n  }\n\n  .right-panel{\n    width:100%;\n    min-height:100vh;\n    padding:20px;\n  }\n\n  .auth-card{\n    width:100%;\n    max-width:420px;\n  }\n}\n.login-stats-grid{\n  display:flex !important;\n  flex-direction:row !important;\n  flex-wrap:nowrap !important;\n  gap:60px !important;\n  width:max-content !important;\n  margin-top:40px !important;\n}\n\n.stat-item{\n  flex-shrink:0 !important;\n}\n.stat-item{\n  display:flex;\n  flex-direction:column;\n  align-items:flex-start;\n  text-align:left;\n}\n\n.stat-item svg{\n  font-size:40px;\n  color:#7a48ee;\n  margin-bottom:10px;\n}\n\n.stat-item h3{\n  color:#fff;\n  font-size:18px;\n  font-weight:700;\n  margin:0 0 8px 0;\n  line-height:1;\n}\n\n.stat-item p{\n  color:#94a3b8;\n  font-size:13px;\n  line-height:1.6;\n  margin:0;\n}\n.login-options{\n  display:flex;\n  justify-content:space-between;\n  align-items:center;\n  margin:10px 0 20px;\n}\n\n.remember-me{\n  display:flex;\n  align-items:center;\n  gap:8px;\n  color:#cbd5e1;\n  font-size:14px;\n  cursor:pointer;\n}\n\n.remember-me input{\n  width:16px;\n  height:16px;\n  margin:0;\n  accent-color:#3b82f6;\n}\n\n.forgot-password{\n  color:#3b82f6;\n  text-decoration:none;\n  font-size:14px;\n}\n\n.forgot-password:hover{\n  color:#8b5cf6;\n}\n.logo-text{\n  margin:0;\n  font-size:36px;\n  font-weight:800;\n  letter-spacing:-1px;\n  line-height:1;\n\n  background:linear-gradient(\n      90deg,\n      #ffffff 0%,\n      #dbeafe 30%,\n      #7dd3fc 60%,\n      #60a5fa 100%\n  );\n\n  -webkit-background-clip:text;\n  -webkit-text-fill-color:transparent;\n\n  text-shadow:\n      0 0 10px rgba(96,165,250,.3),\n      0 0 20px rgba(96,165,250,.2);\n}\n.logo-text::after{\n  content:\"InWallz\";\n  position:absolute;\n  left:0;\n  top:0;\n  z-index:-1;\n\n  background:linear-gradient(\n    135deg,\n    #60a5fa,\n    #8b5cf6\n  );\n\n  -webkit-background-clip:text;\n  -webkit-text-fill-color:transparent;\n\n  filter:blur(18px);\n  opacity:.6;\n}\n.login-logo{\n  width:140px;\n  display:block;\n  margin:0 auto 15px;\n\n  filter:\n    drop-shadow(0 0 8px rgba(0,212,255,.4))\n    drop-shadow(0 0 15px rgba(139,92,246,.3));\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
